import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import ordersService from "../../services/orders.service";
import { OrderResponse } from "types/order.types";

interface OrdersState {
  items: OrderResponse[];
  //   total: number;
  loading: boolean;
  error: string | null;
  //   page: number;
  //   pageSize: number;
}

const initialState: OrdersState = {
  items: [],
  //   total: 0,
  loading: false,
  error: null,
  //   page: 1,
  //   pageSize: 10,
};

export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (params: {
    page?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
    search?: string;
  }) => {
    const response = await ordersService.getOrders(params);
    return response;
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    resetOrdersState: (state) => {
      state.items = [];
      // state.total = 0;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data ?? [];
        // state.total = action.payload.length;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch orders";
      });
  },
});

export const { resetOrdersState } = ordersSlice.actions;
export default ordersSlice.reducer;
